import React from "react";
import { useTranslation } from "react-i18next";
import MDialog from "@/components/ui/atoms/MDialog";

export interface StopMedicationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const StopMedicationModal: React.FC<StopMedicationModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const { t } = useTranslation();

  return (
    <MDialog
      isOpen={open}
      onClose={onClose}
      title={t("pillbox.stopModal.title")}
      description={t("pillbox.stopModal.description")}
      secondaryCtaText={t("common.cancel")}
      onSecondaryCta={onClose}
      primaryCtaText={t("common.confirm")}
      onPrimaryCta={onConfirm}
      isPrimaryCtaLoading={loading}
    />
  );
};

export default StopMedicationModal;
